export default __webpack_public_path__ + "static/TinyCam-Monitor_18-0ba89adb1ffa22bbc3c65904ecacbd2c.webp";